import { Component, OnInit, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.less']
})
export class CodeComponent implements OnInit {
  @Input() code: any;

  constructor( private element : ElementRef ) {}

  ngOnInit() {
  }

  

  copyCode(){
    const codeContent = this.element.nativeElement.querySelector('.copy-content');
    console.info(codeContent);
    var range = document.createRange();
    range.selectNode(codeContent);
    window.getSelection().removeAllRanges();  
    window.getSelection().addRange(range);
    document.execCommand('copy');
    alert('复制成功');
  }
}



// WEBPACK FOOTER //
// ./src/app/component/code/code/code.component.ts